import { montserratRegular, montserratBold } from "../assets/fonts/montserrat";

export const FONT_MONTSERRAT = "Montserrat";

export const registerMontserrat = (doc) => {
  try {
    // Evita registrazioni duplicate
    if (doc.getFontList && doc.getFontList()[FONT_MONTSERRAT]) {
      return;
    }
    doc.addFileToVFS("Montserrat-Regular.ttf", montserratRegular);
    doc.addFileToVFS("Montserrat-Bold.ttf", montserratBold);
    doc.addFont("Montserrat-Regular.ttf", FONT_MONTSERRAT, "normal");
    doc.addFont("Montserrat-Bold.ttf", FONT_MONTSERRAT, "bold");
  } catch (_err) {
    // Se fallisce, jsPDF userà il font di default
  }
};

